module.exports = __webpack_public_path__ + "static/img/brees-2018-slide-8.4fb8ed1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2018-slide-8.jpg
// module id = +JDj
// module chunks = 1